import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@ot/shared/model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  Environment,
  EnvironmentConfigService,
  IftaServiceName
} from '../environment';

@Injectable({
  providedIn: 'root'
})
export class IftaConstantsService {
  _serviceUrl = null;
  constructor(
    @Inject(ENVIRONMENT) private environment: Environment,
    private http: HttpClient,
    private environmentConfigService: EnvironmentConfigService
  ) {
    this._serviceUrl =
      this.environmentConfigService.getEnvironmentConfigs().apis.ifta.url +
      '/' +
      this.environment.serviceUrlList[IftaServiceName.IftaConstantsService];
  }

  getQuarters(): Observable<string[]> {
    return this.http.get<string[]>(`${this._serviceUrl}/quarters`);
  }

  getCurrentQuarter(): Observable<string> {
    return this.getQuarters().pipe(
      map(quarters => quarters[quarters.length - 1])
    );
  }

  getDatesforQuarter(quarter: string): Observable<string[]> {
    const params = new HttpParams().set('quarter', quarter);
    return this.http.get<string[]>(`${this._serviceUrl}/dates`, { params });
  }
}
